import { LegalDoc } from "components/legal/legal.types";

export const LEGAL_DOCS: LegalDoc[] = [{
  id: 'data',
  fileName: 'data_processing_addendum.pdf',
  title: 'Data Processing Addendum',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum DPA', 'Libum data processing addendum', 'Libum legal agreements'],
  currentAsOf: 'January 31, 2024',
},{
  id: 'msa',
  fileName: 'master_services_agreement.pdf',
  title: 'Master Services Agreement',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum MSA', 'Libum master services agreement', 'Libum legal agreements'],
  currentAsOf: 'February 1, 2024',
},{
  id: 'privacy',
  fileName: 'privacy_policy.pdf',
  title: 'Privacy Policy',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum privacy policy', 'Libum legal policies'],
  currentAsOf: 'January 17, 2024',
},{
  id: 'sla',
  fileName: 'service_level_agreement.pdf',
  title: 'Service Level Agreement',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum SLA', 'Libum service level agreement', 'Libum legal agreements'],
  currentAsOf: 'February 2, 2024',
}];
